import React from 'react';
import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export interface SecondViewProps {
  className?: string;
}

const Component: React.FC<SecondViewProps> = ({ className = '' }) => {
  const RootContainer = styled('section')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f2f3fb66',
  }));

  const IconBox = styled('div')(({ theme }) => ({
    '& > img': {
      width: '80px',
    },
  }));

  const HeadingComponent = styled('h2')(({ theme }) => ({
    margin: theme.spacing(2, 0),
    textAlign: 'center',
  }));

  const DescriptionComponent = styled('p')(({ theme }) => ({
    fontSize: '16px',
    lineHeight: '24px',
    padding: theme.spacing(0, 2),
    maxWidth: '720px',
  }));

  return (
    <RootContainer className={className}>
      <IconBox>
        <img
          src={`${process.env.PUBLIC_URL}/images/workflow.png`}
          alt={'workflow icon'}
        />
      </IconBox>
      <article>
        <Typography component={HeadingComponent} variant="h2">
          Workflowとは
        </Typography>
        <Typography component={DescriptionComponent}>
          Workflowは、<strong>現場で簡単</strong>
          に利用することができるワークフローサービスです。
        </Typography>
        <Typography component={DescriptionComponent}>
          スプレッドシート形式の申請フォームのため
          <strong>使い慣れた操作感</strong>で設定することができ、
          ドラッグ＆ドロップで<strong>直感的</strong>
          にワークフローの設計ができるため、技術力がなくても簡単に現場部門で導入・運用することができます。
        </Typography>
      </article>
    </RootContainer>
  );
};

export const Overview = React.memo(Component);
